'use client';

import connectToForm from '@frontend/jetlend-core/src/ducks/connectToForm';
import {
    buildClassNames,
    mergeClassNames,
} from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import Button from '@frontend/jetlend-web-ui/src/ui/inputs/Button/Button';
import DadataInlineTextInput, { renderCompanyItem } from '@frontend/jetlend-web-ui/src/ui/inputs/DadataInlineTextInput/DadataInlineTextInput';
import { useActions } from '@frontend/jetlend-core/src/hooks/useActions';
import { IProps as InlineTextInputProps } from '@frontend/jetlend-web-ui/src/ui/inputs/InlineTextInput/InlineTextInput';
import { DadataType } from '@frontend/jetlend-core/src/models/dadata';
import {
    limitPrescoringRequestFormHandler,
    selectAccountInnHandler,
} from '@app/ducks/borrowers/borrowers';
import styles from './LimitPrescoringForm.module.scss';
import { BorrowerLimitPrescoringContacts } from '@app/models/borrowers/limitPrescoring';


interface IProps extends Pick<InlineTextInputProps, 'white'> {
    /**
     * Текст кнопки
     */
    buttonText?: string;
    /**
     * Название класса для контейнера кнопки
     */
    containerClassName?: string;
    /**
     * Тип формы (просто кнопка или форма с полем ввода)
     */
    type?: 'button' | 'form';
    /**
     * Горизонтальное выравнивание
     */
    align?: 'left' | 'center' | 'right';
}

const formatCompanyInn = suggestion => suggestion?.data?.inn;

/**
 * Форма для начала скоринга лимита заёмщика (с полем ввода ИНН)
 */
export default connectToForm<IProps, Omit<BorrowerLimitPrescoringContacts, 'inn'>>(function LimitPrescoringForm({
    buttonText,
    containerClassName,
    handleSubmit,
    formSubmitting,
    white,
    align = 'left',
}) {
    const text = buttonText || 'Подать заявку на займ';
    const selectInn = useActions(selectAccountInnHandler.action);

    return (
        <form className={mergeClassNames([styles['container'], containerClassName])}>
            <div className={buildClassNames(styles, ['wrapper', `wrapper--${align}`])}>
                <DadataInlineTextInput
                    name="inn"
                    label="ИНН"
                    inputType="text"
                    className={styles['input']}
                    disabled={formSubmitting}
                    dadataType={DadataType.Company}
                    dadataToken={process.env.NEXT_PUBLIC_DADATA_TOKEN}
                    renderItem={renderCompanyItem}
                    formatSelected={formatCompanyInn}
                    onSuggestionSelect={selectInn}
                    maxLength={12}
                    noMarginBottom
                    white={white}
                />
                <Button
                    text={text}
                    size="big"
                    onClick={handleSubmit}
                    className={buildClassNames(styles, ['button', 'button--with-input'])}
                    containerClassName={styles['button-container']}
                    textClassName={styles['button-text']}
                    width={250}
                />
            </div>
        </form>
    );
}, limitPrescoringRequestFormHandler);